import { IconLock } from '@tabler/icons-react';
import { useNavigate } from 'react-router-dom';
import { AuthLogo } from './AuthLogo';
import { useAuthStore } from '../store/auth.store';
import { broadcastAuth } from '../lib/auth-broadcast';

/**
 * [AB#907] Tela cheia (fora do `AppShell` — mesmo nível de `ContaSuspensa.tsx`) mostrada
 * quando o tenant está bloqueado (trial vencido) e o usuário logado NÃO tem
 * `config.assinatura:ler`. Antes desta entrega, `TenantLayout` mandava TODO mundo pra
 * `/minha-conta/assinatura` nesse estado — quem não tinha a permissão só trocava um beco
 * (bloqueio sem explicação) por outro (a tela carregava e caía num `AcessoNegado` genérico,
 * que nem cita o motivo real). Esta tela substitui esse segundo beco: fica na própria
 * navegação, SEM redirecionar (sem loop, sem histórico extra — mesmo princípio do
 * `AcessoNegado`), com a saída (logout) sempre disponível.
 *
 * Reaproveita o padrão visual de `ContaSuspensa.tsx` (mesma família de tela de bloqueio de
 * sessão inteira, fora do `AppShell`) em vez do `EmptyState`/`PageHead` de `AcessoNegado` —
 * aqueles dois assumem o chrome do `AppShell` em volta, que não faz sentido aqui: com o
 * tenant bloqueado, o menu não levaria a lugar nenhum (toda rota fora de
 * assinatura/chamados já toma 403 no backend).
 */
export function AcessoSuspensoSemPermissao(): JSX.Element {
  const navigate = useNavigate();
  const logout = useAuthStore((s) => s.logout);

  async function sair(): Promise<void> {
    await logout();
    broadcastAuth('LOGOUT');
    navigate('/login');
  }

  return (
    <div className="flex min-h-screen flex-col bg-canvas">
      <header className="px-6 pt-6">
        <AuthLogo />
      </header>
      <main className="flex flex-1 items-center justify-center px-6 py-10">
        <div className="w-full max-w-xl rounded-2xl border border-slate-200 bg-white p-8 text-center shadow-sm">
          <div className="mx-auto mb-4 inline-flex h-12 w-12 items-center justify-center rounded-full bg-slate-100 text-slate-500">
            <IconLock size={24} />
          </div>
          <h1 className="text-2xl font-bold tracking-tight text-slate-900">Acesso suspenso</h1>
          <p className="mt-2 text-sm text-slate-600">Fale com o administrador da sua empresa.</p>
          <div className="mt-6 flex justify-center">
            <button
              type="button"
              onClick={() => void sair()}
              className="inline-flex h-10 items-center rounded-md border border-slate-300 bg-white px-5 text-sm font-semibold text-slate-700 hover:bg-slate-50"
            >
              Sair
            </button>
          </div>
        </div>
      </main>
    </div>
  );
}
